import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ProgressSpinner } from 'primereact/progressspinner';
        
const Invitation = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const inviteCode = searchParams.get('inviteCode') || '';
    const [loadingPage, setLoadingPage] = useState(false);

    useEffect(() => {
        // Call API to get initial data
        setLoadingPage(true);
        axios.get('/BBAuthentication/Invitation',{params: { inviteCode : inviteCode}})
            .then(response => {
                const data = response.data;
                navigate(data.RedirectPage, data.ErrorMessage ? { state: { ErrorMessage: data.ErrorMessage } } : undefined);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            })
            .finally(()=>{
                setLoadingPage(false);
            });
    }, []);

    return (
        <div className='text-center'>
            {loadingPage && (
                <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
            )}
        </div>
    )
};

export default Invitation; 